import { render, staticRenderFns } from "./listPermission.vue?vue&type=template&id=158c39dd&"
import script from "./listPermission.vue?vue&type=script&lang=js&"
export * from "./listPermission.vue?vue&type=script&lang=js&"
import style0 from "./listPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports